import {toast as reactToast } from 'react-toastify';
import Toast from '../components/layout/Toast';
import React from 'react';

export const toast = (title: string, content: string) => reactToast(({ closeToast }) => <Toast title={title}>{ content }</Toast>);
export const error = (content: string) => toast('Error', content);
export const info = (content: string) => toast('Info', content);
